import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Button } from "antd";
import { UploadWall } from '@cm-sites-webber/components';

import './style.css';
const InputProps = {...Input.defaultProps,...Input.propTypes}

/**
 * Input文本输入框
 */
class RmtUpload extends PureComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
        };

        this.uploadRef = React.createRef();
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtUpload.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const { buttonProps={} } = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const { prefixLayout, suffixLayout, style={}, suffixButton,uploadButtonName="上传文件" } = this.props.fieldProps;
        const { fieldProps, suffixWidth } =this.state;
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout&&<div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={{...style,flexGrow: 0}} >
                        <UploadWall
                            ref={this.uploadRef}
                            showUploadBtn={false}
                            showUploadDisplayBtn={true}
                            {...fieldProps}
                            onChange={(e)=>fieldProps.onChange(e)}
                        />
                        <Button {...fieldProps} onClick={()=>{this.uploadRef.current.uploadDisplayBtnClick()}}>{uploadButtonName}</Button>
                    </div>
                    {
                        (!!suffixLayout || !suffixButton)&&<div className="rmt-input-suffix-layout">{suffixLayout.apply(this)}</div>
                    }
                    {
                        (!!suffixButton&&!suffixLayout)&&<div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

   // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}
export default RmtUpload;

RmtUpload.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtUpload.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
}